import MCategoryTitle from './m-category-tile';

export default MCategoryTitle;